module.exports = __webpack_public_path__ + "img/v4_contractDeal.ac597fc9.png";